import PropTypes from 'prop-types';
import React from 'react';
export function Slot({
  name,
  content,
  children
}) {
  if (content && name) return content === null || content === void 0 ? void 0 : content[name];
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
Slot.propTypes = {
  name: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object,
  children: PropTypes.node
};